export abstract class IWebHttpErroResponse<T = any> extends Error {
    public type: string = "";
    public statusCode: number = 0;
    public status: string = "";
    public mensagem: string = "";
    public data: T | null = null;
    abstract isInstancia(objeto: any): boolean;
    public toString() {
        return this.mensagem;
    }
}

export default class WebHttpErroResponse<T = any> extends IWebHttpErroResponse<T> {
    constructor(info?:IWebHttpErroResponse) {
        super();
        this.type = "WebHttpErroResponse";
        this.statusCode = info?.statusCode ?? 0;
        this.status = info?.status ?? "";
        this.mensagem = info?.mensagem ?? "";
        this.data = info?.data ?? null;
    }
    public isInstancia(objeto:  any): boolean {
        return objeto !== undefined && objeto !== null && (objeto as IWebHttpErroResponse).type == "WebHttpErroResponse";
    }
}
